var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.section.label || _vm.section.section)?_c('v-row',{staticClass:"sectionTitle"},[_c('v-col',{staticClass:"pt-0"},[_c('h2',[_vm._v(_vm._s(_vm.section.label || _vm.section.section))])])],1):_vm._e(),_c('v-row',{staticClass:"chartRow"},[_c('DoughnutChart',{attrs:{"chartData":_vm.chartData,"showLegend":true,"height":150}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }